const redirectToPage = (router, locale, link) => {
  const coachingCornerLink = '/coachingcorner'
  if (link == coachingCornerLink || link?.includes(coachingCornerLink))
    window.location.href = `${link}`
  else window.location.href = `/${locale}${link}`
}

export default redirectToPage
